// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"369d66c1","977":"1b298ce0"}[chunkId] + ".chunk.js";
};